import { LocalService } from './../storage/local.service';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ConfigService } from '../config/config.service';
import { Oficinas } from '../../interfaces/oficinas';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class OficinasService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService,
    private localSecureService: LocalService
  ) { }

  async getOficinas() {
    //const config = await this.config.getConfig();
    const customer = this.localSecureService.getValue('customer');
    const params = `clientName=${customer['slug']}&version=${API_ENDPOINT.version}`;
    const url = `${API_ENDPOINT.endpoint}/${customer['slug']}/oficinas?${params}`;

    try {
      return await this.httpClient.get<Oficinas>(url).toPromise();
    } catch (error: any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

}
